/**
 * ctp-init.js — CambiaTuPantalla global initializations
 * - Header glass effect on scroll
 * - Scroll-driven card/section animations
 * - Screen Finder cascade selects logic
 */
(function () {
  'use strict';

  /* ---- 1. Header glass effect ------------------------------------------ */
  function initHeaderGlass() {
    var header = document.querySelector('.header');
    if (!header) return;
    var threshold = 60;

    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* ---- 2. Scroll-driven reveal animations ------------------------------ */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var targets = document.querySelectorAll(
      '.card-wrapper, .collection-card, .featured-product, ' +
      '[data-section-type="hero"] .hero__content, ' +
      '.ctp-trust-bar__item, .ctp-finder'
    );

    targets.forEach(function (el, i) {
      el.classList.add('ctp-animate');
      var delay = Math.min(i % 4, 3);
      if (delay > 0) el.classList.add('ctp-animate--delay-' + delay);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ctp-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---- 3. Screen Finder cascade ---------------------------------------- */
  function initScreenFinder() {
    var finder = document.getElementById('ctp-screen-finder');
    if (!finder) return;

    var selBrand = finder.querySelector('[data-finder="brand"]');
    var selSize  = finder.querySelector('[data-finder="size"]');
    var selModel = finder.querySelector('[data-finder="model"]');
    var btnFind  = finder.querySelector('[data-finder="submit"]');

    if (!selBrand) return;

    /* Brand → unlock size */
    selBrand.addEventListener('change', function () {
      if (selSize) {
        selSize.disabled = this.value === '';
        selSize.value = '';
        if (selModel) { selModel.disabled = true; selModel.value = ''; }
        if (btnFind)  btnFind.disabled = true;
      } else {
        if (btnFind) btnFind.disabled = this.value === '';
      }
    });

    /* Size → unlock model (if present) or button */
    if (selSize) {
      selSize.addEventListener('change', function () {
        if (selModel) {
          selModel.disabled = this.value === '';
          selModel.value = '';
          if (btnFind) btnFind.disabled = true;
        } else {
          if (btnFind) btnFind.disabled = this.value === '';
        }
      });
    }

    /* Model → unlock button */
    if (selModel) {
      selModel.addEventListener('change', function () {
        if (btnFind) btnFind.disabled = this.value === '';
      });
    }

    /* Submit — build collection URL */
    if (btnFind) {
      finder.addEventListener('submit', function (e) {
        e.preventDefault();
        var brand = selBrand ? selBrand.value : '';
        var size  = selSize  ? selSize.value  : '';
        var model = selModel ? selModel.value : '';

        /* Priority: model handle > size > brand */
        var dest = model || size || brand;
        if (dest) {
          window.location.href = '/collections/' + dest;
        }
      });
    }
  }

  /* ---- Bootstrap -------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeaderGlass();
      initScrollAnimations();
      initScreenFinder();
    });
  } else {
    initHeaderGlass();
    initScrollAnimations();
    initScreenFinder();
  }
})();
